import { useRef, useLayoutEffect } from "react";
import canElementsAnimate from "./canElementsAnimate";
import getElementsPositions from "./getElementsPositions";
import usePreviousPositionRecording from "./usePreviousPositionRecording";
import getElementsToAnimate from "./getElementsToAnimate";
import animateElements from "./animateElements";
import prefersReducedAnimation from "./prefersReducedAnimation";

const removeEmptyKeys = obj =>
  Object.entries(obj).reduce(
    (result, [key, value]) =>
      value === null || value === undefined
        ? result
        : { ...result, [key]: value },
    {}
  );

function useAnimatedTransition({ reactElements, disableAnimation }) {
  const childRefs = useRef({});

  const domElements = removeEmptyKeys(childRefs.current);

  const recordedPositions = usePreviousPositionRecording({
    reactElements,
    domElements
  });

  useLayoutEffect(() => {
    if (disableAnimation || prefersReducedAnimation()) {
      return;
    }

    if (!canElementsAnimate({ domElements, recordedPositions })) {
      return;
    }

    const newPositions = getElementsPositions({
      reactElements,
      domElements
    });

    const toAnimate = getElementsToAnimate({ newPositions, recordedPositions });

    return animateElements({ toAnimate });
  }, [reactElements.length]);

  return childRefs;
}

export default useAnimatedTransition;
